import React from 'react';
import format from 'string-template';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';

import {
    CONTEXT_ROOT,
    IS_DEV,
    STATIC_ROOT,
    URL_PAGE_FACEBOOK,
    URL_PAGE_GOOGLEPLUS,
    URL_PAGE_TWITTER
} from '../../constants';
import { PATH } from '../../constants/path';
import { GOOGLE, APPLE } from '../../constants/mobile';
import { DEFAULT_LOCALE, LOCALES } from '../../constants/locale';
import {
    MODAL_TYPE_ENROLL,
    MODAL_TYPE_DISENROL,
    MODAL_TYPE_GIVEAWAY,
    MODAL_TYPE_GIVEAWAY_END,
    MODAL_TYPE_TREES_PAYMENT_MODAL
} from '../../services/modal/constants';

import { showModal } from '../../services/modal/actions';

import DownloadButton from '../button/DownloadButton';
import LocalizedNavLink from '../router/LocalizedNavLink';

import './FooterComponent.scss';

const unlocalizedCurrentPath = () =>
    LOCALES.reduce((acc, cur) => acc.replace(`/${cur}/`, '/'), window.location.pathname);

class FooterComponent extends React.Component {
    showEnrollModal = () => event => {
        const { showModal } = this.props;
        event.preventDefault();
        showModal(MODAL_TYPE_ENROLL);
    };
    showDisenrollModal = () => event => {
        const { showModal } = this.props;
        event.preventDefault();
        showModal(MODAL_TYPE_DISENROL, {
            id: 'disenroll-modal'
        });
    };
    showGiveawayModal = () => event => {
        const { showModal } = this.props;
        event.preventDefault();
        showModal(MODAL_TYPE_GIVEAWAY, {
            id: 'giveaway-modal'
        });
    };
    showGiveawayEndModal = () => event => {
        const { showModal } = this.props;
        event.preventDefault();
        showModal(MODAL_TYPE_GIVEAWAY_END, {
            id: 'giveaway-end-winners-modal'
        });
    };
    showTreesPaymentModal = () => event => {
        const { showModal } = this.props;
        event.preventDefault();
        showModal(MODAL_TYPE_TREES_PAYMENT_MODAL, {
            id: 'trees-payment-modal'
        });
    };

    renderDevLanguageLink = () => {
        if (LOCALES.length) {
            return (
                <div className="dev-div">
                    Changer de langue :
                    {/* On force un reload de l'app pour changer de langue, seule solution trouvé pour le moment pour que le changement soit effectif */}
                    {LOCALES.map((locale, i, all) => (
                        <a
                            href={`${CONTEXT_ROOT}${
                                locale === DEFAULT_LOCALE ? '' : `/${locale}`
                            }${unlocalizedCurrentPath()}`}
                            key={i}>
                            {' '}
                            {locale} {i === all.length - 1 ? '' : '|'}
                        </a>
                    ))}
                </div>
            );
        }
    };

    renderDevLink = () => {
        return (
            <div>
                <p>
                    <span className="fakelink" onClick={this.showEnrollModal()}>
                        Modale enrollement
                    </span>
                </p>
                <p>
                    <span className="fakelink" onClick={this.showDisenrollModal()}>
                        Modale désenrollement
                    </span>
                </p>
                <p>
                    <span className="fakelink" onClick={this.showGiveawayModal()}>
                        Modale jeu concours
                    </span>
                </p>
                <p>
                    <span className="fakelink" onClick={this.showGiveawayEndModal()}>
                        Modale fin du jeu concours
                    </span>
                </p>
                <p>
                    <span className="fakelink" onClick={this.showTreesPaymentModal()}>
                        Modale Plantation d'arbres
                    </span>
                </p>
            </div>
        );
    };

    renderDevStuff = () => {
        if (IS_DEV) {
            return (
                <div className="conteneur conteneur-mobile">
                    <hr />
                    {this.renderDevLanguageLink()}
                    {this.renderDevLink()}
                </div>
            );
        }
    };

    renderSocialMedia = () => {
        const { i18n, BRAND_NAME } = this.props;

        if (URL_PAGE_FACEBOOK || URL_PAGE_TWITTER || URL_PAGE_GOOGLEPLUS) {
            return (
                <div className="reseaux-sociaux">
                    <p className="bold hidden-mobonly">{i18n.TITLE_SMO}</p>
                    <div>
                        {URL_PAGE_FACEBOOK && (
                            <LocalizedNavLink
                                to={URL_PAGE_FACEBOOK}
                                target="_blank"
                                title={format(i18n.FACEBOOK_ICON, BRAND_NAME)}>
                                <img
                                    src={`${STATIC_ROOT}/facebook-rond.png`}
                                    alt={format(i18n.FACEBOOK_ICON, BRAND_NAME)}
                                    width="57"
                                    height="57"
                                />
                            </LocalizedNavLink>
                        )}
                        {URL_PAGE_TWITTER && (
                            <LocalizedNavLink
                                to={URL_PAGE_TWITTER}
                                target="_blank"
                                title={format(i18n.TWITTER_ICON, BRAND_NAME)}>
                                <img
                                    src={`${STATIC_ROOT}/twitter-rond.png`}
                                    alt={format(i18n.TWITTER_ICON, BRAND_NAME)}
                                    width="57"
                                    height="57"
                                />
                            </LocalizedNavLink>
                        )}
                        {URL_PAGE_GOOGLEPLUS && (
                            <LocalizedNavLink
                                to={URL_PAGE_GOOGLEPLUS}
                                target="_blank"
                                title={format(i18n.GOOGLEPLUS_ICON, BRAND_NAME)}>
                                <img
                                    src={`${STATIC_ROOT}/googleplus-rond.png`}
                                    alt={format(i18n.GOOGLEPLUS_ICON, BRAND_NAME)}
                                    width="57"
                                    height="57"
                                />
                            </LocalizedNavLink>
                        )}
                    </div>
                </div>
            );
        }
    };

    renderMobileAppButtons = () => {
        const { i18n } = this.props;

        return (
            <div className="mobile-app">
                <p className="bold">{i18n.TITLE_MOBILE_APP}</p>
                <div className="button-wrapper">
                    <DownloadButton type={GOOGLE} inverted />
                    <DownloadButton type={APPLE} inverted />
                </div>
            </div>
        );
    };

    showCmp() {
        window.Didomi.preferences.show();
    }

    handleKeyDown = e => {
        if (e.key === 'Enter') {
            window.Didomi.preferences.show();
        }
    };

    render() {
        const { i18n } = this.props;
        return (
            <footer id="pied-de-page" role="contentinfo" className="pieddepage">
                <div className="conteneur conteneur-mobile">
                    <ul>
                        <li>
                            <LocalizedNavLink to={PATH.FAQ_PATH} title={i18n.LINKS.FAQ.TITLE}>
                                {i18n.LINKS.FAQ.TEXT}
                            </LocalizedNavLink>
                        </li>
                        <li>
                            <LocalizedNavLink
                                to={PATH.CONTACTREQUEST_PATH}
                                title={i18n.LINKS.CUSTOMER_SERVICE.TITLE}>
                                {i18n.LINKS.CUSTOMER_SERVICE.TEXT}
                            </LocalizedNavLink>
                        </li>
                        <li>
                            <a
                                href="https://www.labanquepostale.fr/particulier/comptes-et-cartes/services-de-cartes/cashback/cgu-cashback.html"
                                target="_blank"
                                rel="noopener noreferrer"
                                title={i18n.LINKS.TERMS_PROGRAM.TITLE}>
                                {i18n.LINKS.TERMS_PROGRAM.TEXT}
                            </a>
                        </li>
                        <li>
                            <a
                                href="https://www.labanquepostale.fr/particulier/footer/cgu-operation-rcs.html"
                                target="_blank"
                                rel="noopener noreferrer"
                                title={i18n.LINKS.TERMS_SITE.TITLE}>
                                {i18n.LINKS.TERMS_SITE.TEXT}
                            </a>
                        </li>
                        <li>
                            <LocalizedNavLink
                                to={PATH.LEGAL_NOTICE_PATH}
                                title={i18n.LINKS.LEGAL_NOTICE.TITLE}>
                                {i18n.LINKS.LEGAL_NOTICE.TEXT}
                            </LocalizedNavLink>
                        </li>
                        <li>
                            <LocalizedNavLink
                                to={PATH.OUR_PARTNERS_PATH}
                                title={i18n.LINKS.OUR_PARTNERS.TITLE}>
                                {i18n.LINKS.OUR_PARTNERS.TEXT}
                            </LocalizedNavLink>
                        </li>
                        <li>
                            <a
                                href="https://www.labanquepostale.fr/particulier/comptes-et-cartes/services-de-cartes/cashback/politique-de-confidentialite.html"
                                target="_blank"
                                rel="noopener noreferrer"
                                title={i18n.LINKS.TERMS_CONFIDENTIALITY.TITLE}>
                                {i18n.LINKS.TERMS_CONFIDENTIALITY.TEXT}
                            </a>
                        </li>
                        <li>
                            <LocalizedNavLink
                                to={PATH.ACCESSIBILITY_DECLARATION_PATH}
                                title={i18n.LINKS.ACCESSIBILITY_DECLARATION.TITLE}>
                                {i18n.LINKS.ACCESSIBILITY_DECLARATION.TEXT}
                            </LocalizedNavLink>
                        </li>
                        <li>
                            <span
                                className="link"
                                tabIndex="0"
                                onKeyDown={this.handleKeyDown}
                                onClick={this.showCmp}>
                                {i18n.CONSENT_CHOICES}
                            </span>
                        </li>
                    </ul>
                    <ul></ul>
                </div>
                {this.renderDevStuff()}
            </footer>
        );
    }
}

FooterComponent.propTypes = {
    i18n: PropTypes.object.isRequired
};

const mapStateToProps = state => {
    return {
        i18n: state.i18n.FOOTER,
        BRAND_NAME: state.i18n.common.BRAND_NAME
    };
};

const mapDispatchToProps = {
    showModal
};

export default connect(mapStateToProps, mapDispatchToProps)(FooterComponent);



// WEBPACK FOOTER //
// ./src/components/footer/FooterComponent.js